export default __webpack_public_path__ + "static/hero-fc99490ed6f3bc3fba3726ad756ae773.webp";